import Router from 'next/router';

import { isSSR } from '../../../utils/browser';
import { BookingQueryParam } from '../params.types';

/**
 * Takes an array of booking params and returns an object of their values
 * keyed to the params.
 */
export function getQuery<T extends BookingQueryParam>(...keys: [T, ...T[]]): { [key in T]?: string } {
  if (isSSR()) return {};

  const { query } = Router;

  const result: { [key in T]?: string } = {};

  keys.forEach(key => {
    const value = query[key];

    if (value) {
      result[key] = Array.isArray(value) ? value[0] : value;
    }
  });

  return result;
}

/**
 * If `value` is `undefined`, delete `param` from query string. Otherwise set the value
 * of `param` to `value`
 *
 * @param param {@link BookingQueryParam}
 * @param value string
 */
const setOrDeleteQuery = async (param: BookingQueryParam, value?: string) => {
  if (isSSR()) return;

  const { route, replace, query } = Router;

  if (value) {
    query[param] = value;
  } else {
    delete query[param];
  }

  await replace({ pathname: route, query }, undefined, { shallow: true });
};

export const setQuery = (param: BookingQueryParam, value: string) => setOrDeleteQuery(param, value);
export const deleteQuery = (param: BookingQueryParam) => setOrDeleteQuery(param);
